module.exports = __webpack_public_path__ + "static/media/chocolate-scrn.5717deac.jpg";